import { render, staticRenderFns } from "./index copy.vue?vue&type=template&id=a9e092d2&scoped=true"
import script from "./index copy.vue?vue&type=script&lang=js"
export * from "./index copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e092d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9e092d2')) {
      api.createRecord('a9e092d2', component.options)
    } else {
      api.reload('a9e092d2', component.options)
    }
    module.hot.accept("./index copy.vue?vue&type=template&id=a9e092d2&scoped=true", function () {
      api.rerender('a9e092d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vab/components/VabFile/index copy.vue"
export default component.exports